import { useEffect, useState } from "react";
import api from "services/api";
import NAVBAR from "components/navbar";
import config from "config";
import { getcodCidade } from "functions/gettabconfig";
import './style.css';
import Tabs from "components/tabs/tabs";
import Turismo from "components/turismo";

function LISTATURISMO() {
    const [ltipo0, setltipo0] = useState([]);
    const [ltipo1, setltipo1] = useState([]);
    const [ltipo2, setltipo2] = useState([]);
    const [ltipo3, setltipo3] = useState([]);
    const [ltipo4, setltipo4] = useState([]);

    useEffect(() => {
        // Busca Turismo para os tipos 0, 1, 2, 3, 4
        const fetchData = async (tipo, setTipo) => {
            try {
                const response = await api.get(`${config.TURISMO}?tipo=${tipo}&cod_cidade=${getcodCidade()}`);
                setTipo(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData(0, setltipo0);
        fetchData(1, setltipo1);
        fetchData(2, setltipo2);
        fetchData(3, setltipo3);
        fetchData(4, setltipo4);
    }, []);

    return (
        <div className="container-fluid mt-page">
            <NAVBAR />

            <h1>Turismo</h1>
            <Tabs>
                <div label="Locais">
                    {ltipo0.map((b) => {
                        return (
                            <div key={`tipo0${b.id_turismo}`}>
                                <Turismo
                                    descricao={b.descricao}
                                    banner={`${config.BASEIMG}${b.url_foto}`}
                                    link={b.url_site}
                                />
                            </div>
                        );
                    })}
                </div>
                <div label="Hoteis">
                {ltipo1.map((b) => {
                        return (
                            <div key={`tipo1${b.id_turismo}`}>
                                <Turismo
                                    descricao={b.descricao}
                                    banner={`${config.BASEIMG}${b.url_foto}`}
                                    link={b.url_site}
                                />
                            </div>
                        );
                    })}
                </div>
                <div label="Alimentação">
                {ltipo2.map((b) => {
                        return (
                            <div key={`tipo2${b.id_turismo}`}>
                                <Turismo
                                    descricao={b.descricao}
                                    banner={`${config.BASEIMG}${b.url_foto}`}
                                    link={b.url_site}
                                />
                            </div>
                        );
                    })}
                </div>
                <div label="Eventos">
                {ltipo3.map((b) => {
                        return (
                            <div key={`tipo3${b.id_turismo}`}>
                                <Turismo
                                    descricao={b.descricao}
                                    banner={`${config.BASEIMG}${b.url_foto}`}
                                    link={b.url_site}
                                />
                            </div>
                        );
                    })}
                </div>
                <div label="Uteis">
                {ltipo4.map((b) => {
                        return (
                            <div key={`tipo4${b.id_turismo}`}>
                                <Turismo
                                    descricao={b.descricao}
                                    banner={`${config.BASEIMG}${b.url_foto}`}
                                    link={b.url_site}
                                />
                            </div>
                        );
                    })}
                </div>
            </Tabs>

        </div>
    );
}

export default LISTATURISMO;